import { Component, input } from '@angular/core';
import { Log, LogList } from '@models/common.model';

@Component({
  selector: 'lgb-console',
  standalone: false,
  templateUrl: './console.html',
  styleUrl: './console.css',
})
export class Console {
  readonly logs=input.required<LogList>();
  readonly loading=input(false);
  readonly valLoad=input(0);
  readonly maxLoad=input(0);
  readonly maxHeight=input<string>(null);

  getClasses(log: Log){
    return {
      'text-success': log.type=='success',
      'text-info': log.type=='info',
      'text-warning': log.type=='warning',
      'bg-error': log.type=='error',
      'text-warning-content': log.type=='error'
    };
  }

  style(){
    return {
      maxHeight: this.maxHeight(),
      overflow: ((this.maxHeight())? "auto" : "")
    }
  }
}